import { Box, Text, VStack } from '@chakra-ui/react';

export interface ReportInfoItem {
  label: string;
  value: string;
}

interface ReportInformationProps {
  items: ReportInfoItem[];
}

// Just displays whatever metadata the page hands it — no fields are computed
// or guessed here, so it can't drift from what the backend actually returns.
export default function ReportInformation({ items }: ReportInformationProps) {
  return (
    <VStack align="stretch" spacing={3}>
      {items.map(item => (
        <Box key={item.label}>
          <Text fontSize="xs" color="gray.500" textTransform="uppercase" fontWeight="600" letterSpacing="0.3px">
            {item.label}
          </Text>
          <Text fontSize="sm" color="gray.800" mt="2px">
            {item.value}
          </Text>
        </Box>
      ))}
    </VStack>
  );
}
